export default "__VITE_ASSET__d7755e81__"